export default __webpack_public_path__ + "static/flywheel-9d0c4b4c5fdac1fe08d42a7059495be7.jpg";